package ui.splash

import androidx.compose.animation.core.CubicBezierEasing
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.esIconPainterResource

@Composable
fun SplashScreen() {
    val jumpAnimation = rememberInfiniteTransition()
    val rotationAnimation = rememberInfiniteTransition()

    val offsetY by jumpAnimation.animateFloat(
        initialValue = 0f,
        targetValue = -40f,
        animationSpec =
            infiniteRepeatable(
                animation =
                    tween(
                        durationMillis = 500,
                        easing = CubicBezierEasing(0.42f, 0f, 0.58f, 1f),
                    ),
                repeatMode = RepeatMode.Reverse,
            ),
    )

    val rotationAngle by rotationAnimation.animateFloat(
        initialValue = 0f,
        targetValue = 360f,
        animationSpec =
            infiniteRepeatable(
                animation =
                    tween(
                        durationMillis = 3000,
                        easing = LinearEasing,
                    ),
                repeatMode = RepeatMode.Restart,
            ),
    )

    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {
        Image(
            painter = esIconPainterResource(EsIcons.Logo),
            contentDescription = "Logo",
            modifier =
                Modifier
                    .width(250.dp)
                    .height(250.dp)
                    .align(Alignment.Center)
                    .offset(y = offsetY.dp)
                    .rotate(rotationAngle),
        )
    }
}
